import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faSliders,faCheck,faPhotoFilm,faStar,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faArrowRight,faBus, faMapLocationDot, faHotel, faMessage, faSquareArrowUpRight,faChevronDown, faMicrophone,faChevronUp, faBowlFood, faMountain} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin, } from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect}from 'react'
import PackageSlider from "./Component/PackageSlider";
import Bookingform from "./Component/bookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Tour",
    days: "8 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.jpeg",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Mountain Flight",
    days: "1 Hours",
    duration: "1 Hours",
    difficulty: "Easy",
    price: 280,
    image: "/img/mounteve/moun1.webp",
    link: "/mountain-flight-nepal-tour"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 2350,
    duration: "10 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/company/airportdslr.jpeg",
  "/img/pokhara/pokhara2dslr.jpeg",
  "/img/pokhara/pokhara4.jpg",
  "/img/company/mewith.jpeg",
  "/img/pokhara/pokhara3dslr.jpeg",
  "/img/pokhara/pokhara1dslr.jpeg",
  "/img/pokhara/tal barahi.webp",
  "/img/company/groupphoto.jpeg",
  "/img/pokhara/pokh.jpg",
  "/img/capital/image-asset.webp",
  "/img/capital/ch.webp",
  "/img/capital/swyambhunath.webp",
];
const Sure = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [count,Setcount]=useState(8);
  const [day1Open, setDay1Open] = useState(false);
  const [day2Open, setDay2Open] = useState(false);
  const [day3Open, setDay3Open] = useState(false);
  const [day4Open, setDay4Open] = useState(false);
  const [day5Open, setDay5Open] = useState(false);
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  const getmul=(qty)=>{
if(qty>=8)return 22000;
    };
    const totalprice =count*getmul(count);
    const [opent, seT] = useState(false);
    const [opente, seTe] = useState(false);
    const [openr, seTr] = useState(false);
     useEffect(()=>{
      if(opent){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[opent]);
    const [activeIndex, setActiveIndex] = useState(null);
    
    const toggleFaq = (index) => {
      if (activeIndex === index) {
        setActiveIndex(null);
      } else {
        setActiveIndex(index);
      }
    };
const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');

const handleLogin = (e) => {
    e.preventDefault();
    if (password === 'tft&htpb2b') {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
    }
  };
if (!isAuthenticated) {
    return (
      <div style={{ zIndex: '1000',backgroundColor: 'red', display: 'flex', height: '0vh', alignItems: 'center', justifyContent: 'center' }}>
        <form onSubmit={handleLogin} style={{ zIndex: '1000',backgroundColor: 'white',display: 'flex', flexDirection: 'column', gap: '1rem', padding: '2rem', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>B2B Partner Access Only</h2>
          <input
            type="password"
            placeholder="Enter access password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ border: '1px solid #ccc', padding: '0.5rem', borderRadius: '4px' }}
          />
          <button type="submit" style={{ backgroundColor: '#2563eb', color: 'white', padding: '0.5rem', borderRadius: '4px', border: 'none', cursor: 'pointer' }}>View Page</button>
        </form>
      </div>
    );
  }
  return (
   <main>
      <TourNav />
      <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">Trip Flyer Travels & Himalayas Travels</h1>

<div className="breadcrumb">
  Kathmandu-Pokhara <span>4 Nights/5 Days Tours</span>
</div>
<div className="everest-image">
    <div className="everest-full">
      <img src="/img/pokhara/tal barahi.webp" alt="error" />
      <div
  className="tourgps"
  onClick={() => setOpen(true)}
>    <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
   </div>
    </div>
    <div className="everest-half">
    <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
        <div className="image-box"> <img src="/img/capital/image-asset.webp" alt="error" /></div>
    </div>
 </div>
 {open && (
<div className="roomModal tourgr">
<div className="roomModal__content">

  <div
    className="roomModal__close"
    onClick={() => setOpen(false)}
  >
    ✕
  </div>

  <img
    src={images[index]}
    alt="big"
    className="roomModal__image"
  />

  <div
    className="roomModal__nav roomModal__nav--left"
    onClick={prev}
  >
    ❮
  </div>

  <div
    className="roomModal__nav roomModal__nav--right"
    onClick={next}
  >
     ❯  
  </div>

  <div className="roomModal__thumbs">
    {images.map((img, i) => (
      <img
        key={i}
        src={img}
        alt="thumb"
        className={
          index === i
            ? "roomModal__thumb active"
            : "roomModal__thumb"
        }
        onClick={() => setIndex(i)}
      />
    ))}
  </div>

</div>
</div>
)}
<div className="Trip-fact">
  <h3>Trip Facts</h3>
  <div className="grid">
    <div className="grid-item">
      <FontAwesomeIcon icon={faCalendarDays}/>
      <div className="grid-item-next">
        <p className='Dur'>Duration</p>
        <p className='Duration'>5 Days</p>
      </div>
    </div>

    <div className="grid-item">
      <FontAwesomeIcon icon={faCloud}/>
      <div className="grid-item-next">
        <p className='Dur'>Best Time</p>
        <p className='Duration'>All Year</p>
      </div>
    </div>

    <div className="grid-item">
      <FontAwesomeIcon icon={faGaugeHigh}/>
      <div className="grid-item-next">
        <p className='Dur'>Grade</p>
        <p className='Duration'>Easy</p>
      </div>
    </div>

    <div className="grid-item">
      <FontAwesomeIcon icon={faBus}/>
      <div className="grid-item-next">
        <p className='Dur'>Transportation</p>
        <p className='Duration'>Private Vehical</p>
      </div>
    </div>

    <div className="grid-item">
      <FontAwesomeIcon icon={faMapLocationDot}/>
      <div className="grid-item-next">
        <p className='Dur'>Type Of Tour</p>
        <p className='Duration'>Cultural and Natural Beauty</p>
      </div>
    </div>

     <div className="grid-item">
      <FontAwesomeIcon icon={faHotel}/>
      <div className="grid-item-next">
        <p className='Dur'>Hotel Included</p>
        <p className='Duration'>3 star</p>
      </div>
    </div>

    <div className="grid-item">
      <FontAwesomeIcon icon={faBowlFood}/>
      <div className="grid-item-next">
        <p className='Dur'>Breakfast, Lunch & Dinner</p>
        <p className='Duration'>Included</p>
      </div>
    </div>

    <div className="grid-item">
      <FontAwesomeIcon icon={faMountain}/>
      <div className="grid-item-next">
        <p className='Dur'>Maximum Elevation</p>
        <p className='Duration'>2551 M</p>
      </div>
    </div>

  </div>

   </div>
   <div className="overview-container"id='overview'>
<div className="heading">Highlights Of Tours</div>
<div className="flex-p">

    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore UNESCO World Heritage sites and living history in Kathmandu.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Relax by the lakes and beneath the shadows of the Annapurna range in Pokhara.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Enjoy stunning Himalayan views from the peaceful Chandragiri Hill summit</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore ancient royal palaces and the sacred monkey temple stupa for unforgettable views of Kathmandu.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Enjoy a peaceful boat ride on the crystal-clear Phewa Lake.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Hear the stories that Google won't tell you.</p>

</div>
</div>
   <div className="overview-container">
<div className="overview-heading">Overview</div>

<div className="overview-text">
Experience the perfect harmony of ancient culture and Himalayan grandeur. This 5-day curated journey takes you from the medieval streets of the Kathmandu Valley to the tranquil lakeside of Pokhara. It is the ideal package for travelers who want to see the "Best of Nepal" without the need for strenuous trekking.
</div>
<div className="heading smalling">Places You’ll Visit:</div>

<div className="flex-p">


<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Swayambhunath (Monkey Temple):</b> Ancient hilltop stupa offering panoramic views and deep Buddhist symbolism.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Boudhanath Stupa:</b> One of the largest spherical stupas in the world.</p>
<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Sarangkot:</b> A famous hilltop destination offering breathtaking sunrise views and a panoramic sweep of the Annapurna Himalayan range.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Kathmandu Durbar Square:</b> A historic complex of palaces, courtyards, and temples reflecting royal Malla history.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Phewa Lake:</b> Nepal's second-largest lake, famous for the Tal Barahi Temple on its island and the stunning reflection of Mount Machhapuchhre on its waters.</p>


  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Chandragiri Hills:</b> you can enjoy breathtaking, wide-ranging views of the Himalayas and the Kathmandu Valley.</p>

</div>
<div className="heading smalling">Introduction Of Places</div>
<p className='overview-text'><b>Boudhanath: The Giant Circle</b> This is one of the biggest stupas in the world, built like a giant meditation map. The air is thick with the smell of butter lamps and the sound of monks chanting. Thousands of people walk in a circle here every day, but the peace you feel inside is a secret you have to experience yourself.</p>
<p className='overview-text'><b>Kathmandu Durbar Square: Secrets of the Living Goddess</b> Walk the same stone paths as ancient kings and seek a glimpse of the Kumari—the world’s only Living Goddess. This "Museum of Living Heritage" is a maze of hidden courtyards and towering pagodas that survived the test of time. There is a specific mystery in the air here, a feeling that a legend could walk around the corner at any moment. Are you ready to step into the palace of shadows and stories?</p>
 <p className='overview-text'><b>Swayambhunath: The All-Seeing Eyes</b> High on a hill, ancient eyes watch over the entire valley. Legend says this place was born from a lotus flower before the city even existed. You will walk among hundreds of monkeys and spinning wheels to find a view that feels like the top of the world. What you see here will stay with you forever.</p>
<p className='overview-text'><b>Sarangkot: The Himalayan Gateway</b> Perched high above the clouds, this hilltop offers the ultimate front-row seat to the Annapurna giants. As the first light of dawn turns the jagged peaks into molten gold, you will feel the immense scale of the mountains. It is a place of quiet wonder and the perfect start to any Pokhara adventure.</p>

<p className='overview-text'><b>Phewa Lake: The Mirror of the Mountains</b> A tranquil expanse of emerald water that perfectly captures the reflection of the sacred Machhapuchhre peak. Whether you are paddling a colorful boat to the island temple or walking along the vibrant shore, the lake offers a sense of peace that calms the soul. It is the true jewel of the Pokhara Valley.</p>

<p className='overview-text'><b>Chandragiri Hills: Scenic peaks, historical views.</b> Soar above the Kathmandu Valley on a scenic cable car ride to a majestic vantage point offering panoramic Himalayan views and echoes of King Prithvi Narayan Shah. Experience tranquil magic and crisp mountain air at this legendary peak where history meets the horizon.</p>

</div>
<div className="overview-container">
<div className="overview-heading">Why This Package ?</div>
<p className='overview-text'>Planning a trip to a new country can be overwhelming. We’ve designed this 6-day "Golden Loop" package to take the stress out of your travels, allowing you to focus entirely on the beauty of the Himalayas and the warmth of Nepali culture:</p>
<div className="heading smalling">See the "Best of Nepal" Without the Hike</div>
 <p className='overview-text'>We’ve curated a perfect itinerary that delivers breathtaking Himalayan sunrises and serene lakeside views—all accessible by private vehicle. No strenuous trekking required!</p>
<div className="heading smalling">Effortless Logistics</div>
<p className='overview-text'>We handle every detail, from private, air-conditioned transport to all permits, so you can enjoy the journey without the stress of planning.</p>
<div className="heading smalling">Deep Cultural Storytelling</div>
<p className='overview-text'>Our English Speaking Local guides don't just show you monuments; they bring the "Living Heritage" of the valley to life through local legends and historical insights.</p>
<div className="heading smalling">Expertly Paced Exploration</div>
<p className='overview-text'>We balance the high-energy sightseeing of Kathmandu’s busy streets with a tranquil, restorative retreat in the clouds.</p>
</div>

<div className="overview-container">
<div className="overview-heading"id='itinerary'>ITINERARY</div>
<div className="timeline-row">
    <div className="timeline-left">
      <div className="day-circle">Day 1</div>
    </div>

    <div
      className="timeline-right"
      onClick={() => setDay1Open(!day1Open)}
    >
     
      <div className="timeline-title">
      Arrival & Welcome
      </div>

      <div className="arrow-icon">
        <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
      </div>
    </div>
  </div>

  {day1Open && (
    <div className="timeline-detail">
 Arrive at Tribhuvan International Airport. Our team will meet you and transfer you to your hotel. Spend the rest of the day relaxing or taking an easy stroll through the vibrant streets of Thamel to soak in the local atmosphere.
    </div>
  )}
<div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 2</div>
    </div>
    <div
      className="timeline-right"
      onClick={() => setDay2Open(!day2Open)}
    > 
      <div className="timeline-title">
     Scenic Drive to Pokhara
      </div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day2Open ? faChevronUp : faChevronDown} />
      </div>
      
    </div>
    
</div>
{day2Open && (
    <div className="timeline-detail">
After breakfast, we begin our scenic drive to Pokhara, the "City of Lakes." The journey takes you through lush green hills and along the Trishuli River. Once you arrive, check into your lakeside hotel and enjoy a peaceful evening watching the sunset with a relaxing boat ride on Phewa Lake.
    </div>
  )}

  <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 3</div>
    </div>
    <div
      className="timeline-right"
      onClick={() => setDay3Open(!day3Open)}
    > 
      <div className="timeline-title">
     Back To Kathmandu & Cable Car Ride
      </div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day3Open ? faChevronUp : faChevronDown} />
      </div>
      
    </div>
    
</div>
{day3Open && (
    <div className="timeline-detail">
 Wake up very early in the morning and drive up to Sarangkot to find a nice spot and watch the sun rise over the high Annapurna mountain range, where the golden morning light on the snow is a sight you will never forget. Go back down to the city for breakfast, and take the scenic road journey back to Kathmandu. Afterward, head over to Chandragiri and take a fun cable car ride up to the top of the mountain to see wide green valleys and white, snowy mountain peaks.
    </div>
  )}
  <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 4</div>
    </div>
    <div
      className="timeline-right"
      onClick={() => setDay4Open(!day4Open)}
    > 
      <div className="timeline-title">
      Sightseeing At Kathmandu
      </div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day4Open ? faChevronUp : faChevronDown} />
      </div>
      
    </div>
    
</div>
{day4Open && (
    <div className="timeline-detail">
Enjoy a full day of sightseeing at Nepal’s UNESCO World Heritage sites. You will visit the historic Kathmandu Durbar Square, the peaceful Boudhanath Stupa, and the hilltop Swayambhunath (Monkey Temple).
    </div>
  )}
 <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 5</div>
    </div>
    <div
      className="timeline-right"
      onClick={() => setDay5Open(!day5Open)}
    > 
      <div className="timeline-title">
      Departure
      </div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day5Open ? faChevronUp : faChevronDown} />
      </div>
      
    </div>
    
</div>
{day5Open && (
    <div className="timeline-detail">
After a wonderful few days of sightseeing, history, and nature, enjoy your last breakfast in Nepal. Pack your bags with great memories, check out of your hotel, and head to the airport for your safe flight back home.
    </div>
  )}
</div>
<div className="overview-container width-hund"id='included'>

<div className="cost-box included">
        <div className="cost-title">Cost Included</div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          Pick Up and Drop with private vehicle is included in this price.
          </div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">A English Speaking Local guide.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Three nights accommodation (Double Sharing) with breakfast at a 3-star category hotel in Kathmandu.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All kind of service charge and Tax is included.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">One night 3 star accommodation (Double Sharing) in Pokhara including breakfast.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Private Ac Vehicle for Transfers and Sightseeing.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All the applicable entrance fees.</div>
        </div>
  <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Lunch and Dinner during the tour.</div>
        </div>
      </div>
</div>
<div className="cost-box excluded">
        <div className="cost-title">Cost Not Included</div>
<div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Chandragiri cable car ticket is not included. It requires an extra 1000 BDT.</div>
        </div>
      

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">International airfare and airport departure tax.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Tips for the guide & driver.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Any others expenses which are not mentioned in including section.</div>
        </div>
      </div>
      <div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> Useful Info
  </div>
  <section className="faq">
          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
            This package is perfectly suited for first-time travelers and families looking for a comprehensive introduction to Nepal without the physical demands of high-altitude trekking. It balances the deep historical roots of the Kathmandu Valley’s ancient squares with the tranquil, natural beauty of Pokhara’s lakeside and caves. Because every destination is accessible by vehicle, it is an excellent choice for senior citizens, photographers, or time-constrained tourists who want to experience Nepal’s heritage and Himalayan views in comfort and style.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies Cancel up to 10 days before in advance for a full refund after 10 days there will no refund of your 10% payment.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Travel Documents:</b> Ensure you have a valid passport and printed copies of your booking confirmation and insurance.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Clothing & Layers:</b> Pack lightweight clothes for the city and a warm jacket for the Nagarkot sunrise, as temperatures drop significantly in the mornings.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Footwear:</b> Bring comfortable walking shoes or sneakers with good grip for navigating the stone-paved streets of Bhaktapur and the hills of Nagarkot.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Health & Safety:</b> Carry a basic first-aid kit, personal medications, and a reusable water bottle to stay hydrated while exploring the heritage sites.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Day Pack:</b> Use a small backpack to keep your camera, power bank, and rain gear handy for sudden mountain weather changes.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Currency & Cash:</b> Keep some local currency (NPR) for personal expenses, tips, and meals not included in the package.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
               <div className="heading smalling">Meal Plan Details</div>

<p className='overview-text'><b>Standard Inclusion:</b> Every morning begins with a fresh, delicious breakfast included at your hotel to fuel your day of exploration. This ensures you start your journey energized and ready for the sights ahead.</p>

<p className='overview-text'><b>Lunch & Dinner (Flexible):</b> To give you complete freedom over your palate, these meals are not included in the base price. Your guide will introduce you to top-rated local restaurants where you can pay directly, allowing you to discover the diverse flavors of Nepal at your own pace.</p>

<p className='overview-text'><b>Full-Board Upgrade (Recommended):</b> For those seeking a truly seamless and worry-free adventure, we can include all lunch and dinner charges in your package. We will handle all the arrangements and payments at every destination, so your only responsibility is to sit back, relax, and enjoy the trip.</p>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
    </section>
  </div>
  <div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a few hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable helicopter flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize" onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review" onClick={()=>seTr(true)}>
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
  
</div>

</div>
      </div>
      <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>22000 BDT</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>For Min 8 Person</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>8){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>৳{totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/legal" className="download">
               
                  <h6>See Legal Documents</h6>
                </Link>
                <div className="booking-btn">
                <button onClick={()=>seT(true)}>Book Now</button>
      <button onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
               src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section></div>
        {opent &&(  <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <Bookingform src="/img/capital/Nagarkot.avif" title="B2B Kathmandu Pokhara"/></section>)}
{opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/capital/Nagarkot.avif" title="B2B Kathmandu Pokhara"/></section>)}
{openr &&(  <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review /></section>)}
   </main>
  )
}
export default Sure